import React from 'react';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { useTranslation } from "react-i18next";
import { useStylesLbl } from '../../../../St/Reports/UseStyle';

export default function FoundationsFourth(props) {

    const {
        changTField,
        params,
    } = props;

    const claslbl = useStylesLbl();
    const { t } = useTranslation(["forms", "translation"]);
    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} justifyContent="center" spacing={2}>
                <Grid
                    item
                    container
                    spacing={1}
                    justifyContent='center'
                    lg={12} md={12} sm={12} xs={12}
                >         
                    <Grid item lg={6} md={6} sm={6} xs={12}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="CStartWorkDate"
                            label="بداية السنه المالية "
                            type="date" format="YYYY-MM-DD"
                            name="CStartWorkDate"
                            value={params.CStartWorkDate}
                            InputLabelProps={{
                                className: claslbl.clrBlackLblS,
                            }}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            onChange={changTField("CStartWorkDate")}
                        />
                    </Grid>


                    <Grid item lg={6} md={6} sm={6} xs={12}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            id="CEndWorkDate"
                            label="نهاية السنه المالية"
                            type="date" format="YYYY-MM-DD"
                            name="CEndWorkDate"
                            value={params.CEndWorkDate}
                            InputLabelProps={{
                                className: claslbl.clrBlackLblS,
                            }}
                            InputProps={{ className: claslbl.clrBlackTxt }}
                            onChange={changTField("CEndWorkDate")}
                        />
                    </Grid>
                </Grid>
            </Grid>



        </React.Fragment>
    );

}